<script lang="ts" setup>

  // Head
  useHead({
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
      }
    ],
    link: [
      {
        rel: 'icon',
        href: '/favicon.ico'
      },
      {
        rel: 'preload',
        href: '/fonts/NHaasGroteskText.woff2',
        as: 'font',
        type: 'font/woff2',
        crossorigin: ''
      },
      {
        rel: 'preload',
        href: '/fonts/NHaasGroteskDisplay-bold.woff2',
        as: 'font',
        type: 'font/woff2',
        crossorigin: ''
      }
    ]
  })

  // Iniciar dia
  const selectedDiaStore = useSelectedDayStore()
  selectedDiaStore.init()

</script>

<template>
  <NuxtLoadingIndicator color="repeating-linear-gradient(to right,#ff620a 0%,#C40058 100%)" />
	<div class="min-h-screen bg-white">
    <Header />
    <main class="w-full max-w-screen-2xl container flex items-center mx-auto flex-col flex-grow">
      <slot />
    </main>
    <Footer />
  </div>
</template>
